import gql from 'graphql-tag';

import {
    SUPPLY_ORDER_DETAILS_FRAGMENT,
    SUPPLY_ORDER_FRAGMENT,
    SUPPLY_ORDER_WITH_SUPPLIER_PRODUCTS_INFO_FRAGMENT,
} from 'data/fragments/supplyOrder';

export const SUPPLY_ORDERS_UPDATED_OR_CREATED_SUBSCRIPTION = gql`
    subscription SUPPLY_ORDERS_UPDATED_OR_CREATED {
        supplyOrdersUpdatedOrCreated {
            ...SupplyOrderFragment
        }
    }
    ${SUPPLY_ORDER_FRAGMENT}
`;

/**
 * Souscription de la fiche d'achat. Elle diffuse TOUS les achats modifiés, quel qu'en soit l'auteur :
 * chaque champ sélectionné ici est donc recalculé à chaque publication, pour chaque abonné. D'où le
 * fragment léger — l'ancienne version embarquait le catalogue fournisseur complet.
 */
export const SUPPLY_ORDER_DETAILS_UPDATED_OR_CREATED_SUBSCRIPTION = gql`
    subscription SUPPLY_ORDER_DETAILS_UPDATED_OR_CREATED {
        supplyOrdersUpdatedOrCreated {
            ...SupplyOrderDetailsFragment
        }
    }
    ${SUPPLY_ORDER_DETAILS_FRAGMENT}
`;

/** Souscription des ACHATS MANUELS : eux travaillent sur le catalogue fournisseur complet. */
export const SUPPLY_ORDERS_WITH_SUPPLIER_PRODUCTS_INFO_UPDATED_OR_CREATED_SUBSCRIPTION = gql`
    subscription SUPPLY_ORDERS_WITH_SUPPLIER_PRODUCTS_INFO_UPDATED_OR_CREATED {
        supplyOrdersUpdatedOrCreated {
            ...SupplyOrderWithSupplierProductsInfoFragment
        }
    }
    ${SUPPLY_ORDER_WITH_SUPPLIER_PRODUCTS_INFO_FRAGMENT}
`;
